import { dayKey, parseLocalDay } from './programs/program-days.js'

/**
 * Temporary access (legacy `initial` code included), whatever its active state.
 * Same rule as the API's Subscription::isTemporaryCode: the API sends the raw
 * code, so case and surrounding spaces are ignored.
 */
export const isTemporarySubscription = (user) => {
    const code = String(user?.subscription?.code || '')
        .trim()
        .toLowerCase()

    return code === 'temporary' || code === 'initial'
}

/**
 * Premium access is decided by the API. The fallback keeps the app compatible
 * while the additive `subscription.premium` field is rolling out.
 */
export const hasPremiumSubscription = (user) => {
    const subscription = user?.subscription

    if (typeof subscription?.premium === 'boolean') return subscription.premium

    const code = String(subscription?.code || '').trim()

    return Boolean(subscription?.active && code && !isTemporarySubscription(user))
}

/**
 * Full application entitlement: any active subscription unlocks the feature,
 * Temporary (`code: 'temporary'`) included. The commercial Premium category
 * remains available separately through hasPremiumSubscription().
 */
export const hasActiveSubscription = (user) => Boolean(user?.subscription?.active)

export const hasSubscriptionAccess = (user) => {
    if (user?.admin) return true

    const subscription = user?.subscription
    if (typeof subscription?.access === 'boolean') return subscription.access
    if (!subscription?.active) return false

    const code = String(subscription?.code || '').trim()

    if (isTemporarySubscription(user)) return true
    if (typeof subscription?.premium === 'boolean') return subscription.premium

    return Boolean(code)
}

/**
 * Last day of the minimum term agreed with the client (`subscription.commitment_end_date`,
 * 'YYYY-MM-DD', typed in the admin), or null once that day is over. The API sends
 * a passed date as is and a cached payload goes stale, so the app checks it here,
 * on local calendar days: the last day still counts.
 */
export const commitmentEndDate = (user, today = new Date()) => {
    const end = parseLocalDay(user?.subscription?.commitment_end_date)
    const day = end && dayKey(end)

    return day && day >= dayKey(today) ? day : null
}

export const isPremiumRequiredError = (error) =>
    error?.response?.status === 403 && error?.response?.data?.code === 'premium_required'
